import { apiClient } from '../../../services/apiClient';

/** URLとして有効か（httpまたは/で始まるか） */
const isValidUrl = (s: string | undefined | null): s is string =>
  !!s && (s.startsWith('http') || s.startsWith('/'));

/**
 * シーンのナレーション表示・読み上げ用テキストを解決する。
 * `script` は後方互換で `narration + dialogue` を連結した値を持つため、narration が
 * 空のときに無条件で `script` へフォールバックすると、セリフのみのシーンでセリフ本文を
 * ナレーションとして表示・読み上げてしまう。ナレーション(画面外の語り手)とセリフ
 * (登場人物の発話)は排他なので、`script` へのフォールバックは「dialogue も空＝
 * narration/dialogue 分離前の旧シーン」に限定する。
 */
export function resolveNarrationText(scene: {
  narration?: string;
  dialogue?: string;
  script?: string;
}): string {
  if (scene.narration) return scene.narration;
  if (scene.dialogue) return '';
  return scene.script || '';
}

/**
 * ナレーション素材の再生可能なURLを解決する。
 * preview_url / source_url が有効なURLでない場合、signed-urlエンドポイントで取得する。
 */
export async function resolveAudioUrl(material: {
  id?: string;
  preview_url?: string;
  source_url?: string;
  public_url?: string;
  storage_bucket?: string;
  storage_path?: string;
}): Promise<string | null> {
  // 1. 有効なURLを探す
  const url = [material.preview_url, material.source_url, material.public_url].find(isValidUrl);
  if (url) return url;

  // 2. signed-urlエンドポイントで取得
  if (material.id) {
    try {
      const { data } = await apiClient.get<{ url: string }>(`/materials/temporary/${material.id}/signed-url`);
      if (isValidUrl(data?.url)) return data.url;
    } catch {
      // フォールバック
    }
  }

  // 3. Supabaseストレージの直接URL
  if (material.storage_bucket && material.storage_path && material.storage_bucket !== 'gcs') {
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://lirsarznxaidebqhgxch.supabase.co';
    return `${supabaseUrl}/storage/v1/object/public/${material.storage_bucket}/${material.storage_path}`;
  }

  return null;
}
